module.exports = __webpack_public_path__ + "static/media/attack.00f35d6d.svg";